import React from "react";
import Navbar from "./sections/Navbar";
import Hero from "./sections/Hero";
import Stats from "./sections/Stats";
import Services from "./sections/Services";
import Sectors from "./sections/Sectors";
import Process from "./sections/Process";
import WhyUs from "./sections/WhyUs";
import Testimonials from "./sections/Testimonials";
import Faq from "./sections/Faq";
import QuoteForm from "./sections/QuoteForm";
import Footer from "./sections/Footer";
import useLenis from "./hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";

export default function LandingPage() {
  useLenis();
  return (
    <div className="relative bg-white text-[#0F172A] overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Sectors />
        <Process />
        <WhyUs />
        <Testimonials />
        <Faq />
        <QuoteForm />
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
}
